export default "__VITE_ASSET__056e4bf9__"